// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../node_modules/mini-css-extract-plugin/dist/loader.js??minicss!../../node_modules/@roots/bud-support/lib/css-loader/index.cjs??css!../../node_modules/postcss-loader/dist/cjs.js??postcss!../../node_modules/resolve-url-loader/index.js??resolve-url!../../node_modules/sass-loader/dist/cjs.js??sass!./app.scss");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("04e91e88", content, true, {});